module.exports = "img/stickerpack-placeholder.9c54c13.png";